import { FinishingLevel } from "common/types/common.types";
import { ClimateRiskType } from "../../../types/appraiser.types";
import i18n from "../../../i18n/i18n";

export const getFinishingLevelLabel = (
  level: string | FinishingLevel | null | undefined
) => {
  const _level = Object.values(FinishingLevel).includes(level as FinishingLevel)
    ? (level as FinishingLevel)
    : null;
  if (!_level) return null;

  return i18n.t(`propertyForm.finishingLevel.${_level}`);
};

export const getPropertyFloodRiskLabel = (
  risk: string | ClimateRiskType | null | undefined
) => {
  if (!risk) return null;

  const _risk = Object.values(ClimateRiskType).includes(risk as ClimateRiskType) ? (risk as ClimateRiskType) : null;

  if (!_risk) return null;

  return i18n.t(`climateRiskType.${_risk}`);
}
